var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.dataLoaded)?_c('div',[_vm._v("Loading Please wait...")]):_c('div',[(_vm.lists.length > 0)?_c('h1',{staticClass:"bevel"},[_vm._v("Trending Lists")]):_vm._e(),_vm._l((_vm.lists),function(list){return _c('ListSummary',{key:list.id,attrs:{"list":list,"compact":true,"header-route":_vm.viewListRoute(list),"show-summary":true}})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }